import { Product, SearchResult } from '@rygen/rygen-ui/model';

export class ProductSearchResult extends SearchResult<Product> {
  constructor(opts?: Partial<ProductSearchResult>) {
    super(opts);

    if (opts?.content != null) {
      this.content = opts.content.map((val) => new Product(val));
    }
  }
}
